import { ENV } from "../constants/envConfig";
const UID_FIELD_NAME = {
  dev: "uid.dev",
  fat: "uid.fat",
  stage: "uid.stage",
  prod: "uid",
};

export const uidFieldName = UID_FIELD_NAME[ENV];

export const tokenFieldName = `token.${ENV}`;
